module.exports = __webpack_public_path__ + "pnskfsquadron/img/m-book-hero4.png?6be2e25f";